import React from 'react';
import { Dropdown } from '@ihsm/ui-shared';

export const CurrencyDropdown: React.FC = () => (
  <Dropdown
    labelText="Currency"
    value="USD"
    options={[{ displayText: 'USD', value: 'USD' }]}
    onChange={() => {}}
    disabled
  />
);
